import { clsx } from 'clsx';
import CrehanaLogoIso from '@crehana/icons/CrehanaLogoIso';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var PoweredBy = function PoweredBy() {
  var textColor = 'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: clsx('tw-font-body5 tw-mr-0.8', textColor),
      children: "Powered by"
    }), /*#__PURE__*/_jsx(CrehanaLogoIso, {
      size: 12,
      ignoreColor: true,
      className: clsx('tw-fill-current -tw-mt-0.4', textColor)
    })]
  });
};